import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { fmtZMW, fmtDate } from "@/lib/helpers";
import { DetailShell, InfoRow, InfoGrid } from "@/components/DetailShell";
import { StatusBadge, Empty } from "@/components/primitives";
import { toast } from "sonner";

export default function RequestDetail() {
  const { id } = useParams();
  const [rq, setRq] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/requests/${id}`);
        setRq(data);
      } catch (e) { toast.error(formatError(e)); }
      finally { setLoading(false); }
    })();
  }, [id]);

  if (loading) return <div className="phizo-label">Loading request…</div>;
  if (!rq) return <Empty label="Request not found." />;

  return (
    <DetailShell
      overline={`REQUEST / ${(rq.type || "").replace("_", " ").toUpperCase()}`}
      title={rq.number}
      subtitle={rq.title}
      backTo="/requests"
      testId="request-detail"
      actions={<StatusBadge status={rq.status} />}
    >
      <InfoGrid cols={3}>
        <InfoRow label="Type" value={(rq.type || "").replace("_", " ")} />
        <InfoRow label="Priority" value={rq.priority || "normal"} />
        <InfoRow label="Requested By" value={rq.requested_by_name} />
        <InfoRow label="Created" value={fmtDate(rq.created_at)} />
        <InfoRow label="Project" value={rq.project_code || "—"} />
        <InfoRow label="Estimated Cost" value={rq.estimated_cost != null ? fmtZMW(rq.estimated_cost) : "—"} />
        {rq.approver_name && <InfoRow label="Decided By" value={rq.approver_name} />}
        {rq.completed_by_name && <InfoRow label="Completed By" value={rq.completed_by_name} />}
      </InfoGrid>

      {rq.description && (
        <div className="mt-6 phizo-card p-4">
          <div className="phizo-label mb-2">Description</div>
          <p className="text-sm whitespace-pre-wrap">{rq.description}</p>
        </div>
      )}
      {rq.justification && (
        <div className="mt-4 phizo-card p-4">
          <div className="phizo-label mb-2">Justification</div>
          <p className="text-sm whitespace-pre-wrap">{rq.justification}</p>
        </div>
      )}
      {rq.notes && (
        <div className="mt-4 phizo-card p-4">
          <div className="phizo-label mb-2">Notes</div>
          <p className="text-sm whitespace-pre-wrap">{rq.notes}</p>
        </div>
      )}

      {Array.isArray(rq.parts) && rq.parts.length > 0 && (
        <div className="mt-6 phizo-card">
          <div className="p-4 border-b border-[#e4e4e7]">
            <div className="phizo-label">Parts Requested</div>
          </div>
          <div className="overflow-x-auto">
            <table className="phizo-table">
              <thead>
                <tr><th>SKU</th><th>Description</th><th className="text-right">Quantity</th></tr>
              </thead>
              <tbody>
                {rq.parts.map((p, i) => (
                  <tr key={i}>
                    <td className="mono text-xs">{p.sku || "—"}</td>
                    <td>{p.description}</td>
                    <td className="text-right mono">{p.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </DetailShell>
  );
}
